import { useEffect, useState, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import {
  setAutoMessageSize,
  setlauncherContent,
  setShowLuancher,
  setShowTrigger,
} from 'app/redux/widget/widget.actions'
import { sendMessage, sendNewTypedWord, setActiveDepartment, setUserInput } from 'app/redux/messages/messages.actions'
import SendMessage from 'app/components/ChatInput/sendMessage'
import { Close } from 'app/components/icons'
import { playNotifSound } from 'app/utils/sound'
import { SmileyIcon, LeftArrow } from 'app/components/icons'
import { Avatar } from 'app/components'
import { LAUNCHER_CONTENT_STATE } from 'app/constants/launcherContentStates'
import './greeting.scss'
import { iframeStyles } from 'app/constants/iframeStyles'

const getShowTrigger = ({ widgetData }) => widgetData.widgetInfo.showTrigger
const getLanguageInfo = ({ widgetData }) => widgetData.widgetInfo.languageInfo
const getShowLauncher = ({ widgetData }) => widgetData.widgetInfo.showLauncher
const getUserInput = ({ messagesData }) => messagesData.messages.userInput
const getDefaultTeam = ({ messagesData }) => messagesData.defaultTeam
const getReplyingMessage = ({ messagesData }) => messagesData.replyingMessage
const getWidgetInfo = ({ widgetData }) => widgetData.widgetInfo
const getShowGreetingInput = ({ messagesData }) => messagesData.showGreetingInput
const getActiveAutoMsg = ({ widgetData }) => widgetData.activeTriggerMsg

const Greeting = () => {
  const showTrigger = useSelector(getShowTrigger)
  const languageInfo = useSelector(getLanguageInfo)
  const showLauncher = useSelector(getShowLauncher)
  const userInput = useSelector(getUserInput)
  const defaultTeam = useSelector(getDefaultTeam)
  const replyingMessage = useSelector(getReplyingMessage)
  const widgetInfo = useSelector(getWidgetInfo)
  const showGreetingInput = useSelector(getShowGreetingInput)
  const activeAutoMessage = useSelector(getActiveAutoMsg)

  const dispatch = useDispatch()
  const [widgetPosition, setWidgetPosition] = useState(null)
  const [msgContentHeight, setMsgContentHeight] = useState(0)
  const [onLoadCalledOnce, setOnLoadCalledOnce] = useState(false)
  const [iframeHeight, setIframeHeight] = useState(0)
  const [inputFocused, setInputFocused] = useState(false)
  const msgContentRef = useRef(null)
  const iframeRef = useRef(null)

  const teamId = activeAutoMessage?.teamId || defaultTeam?._id
  const userInputValue = userInput[teamId] || ''
  const shouldPlayNotifSound = activeAutoMessage?.mute
  const shouldTruncateMessage = activeAutoMessage?.displayMode !== 'complete'

  const handleUserInput = (e) => {
    const value = e.target.value

    dispatch(setUserInput(value, teamId))
  }

  const openWidgetAfterSendingMsg = () => {
    if (!showLauncher) {
      dispatch(setActiveDepartment(teamId))
      dispatch(setlauncherContent(LAUNCHER_CONTENT_STATE.FIRST_CHAT))
      dispatch(setShowLuancher(true))
    }
  }

  const sendNewMessage = () => {
    if (userInputValue && userInputValue.trim() !== '') {
      const tmpId = Math.random().toString(36).substring(7)

      const newMessage = {
        content: userInputValue,
        me: true,
        type: 'text',
        status: 'pending',
        createdAt: new Date(),
        tmpId,
      }

      if (replyingMessage?.id) newMessage['replyId'] = replyingMessage?.id

      dispatch(
        sendMessage({
          message: newMessage,
          teamId,
        }),
      )

      dispatch(setUserInput('', teamId))

      openWidgetAfterSendingMsg()
    }
  }

  const handleKeyDown = (e) => {
    if (!e || (e && e.key === 'Enter')) {
      sendNewMessage(e)
    }
    if (!e || e.key === ' ' || e.key === 'Spacebar') {
      dispatch(sendNewTypedWord(userInputValue))
    }
  }

  const handleClickGreeting = () => {
    dispatch(setShowLuancher(true))
    dispatch(setlauncherContent(LAUNCHER_CONTENT_STATE.FIRST_CHAT))
    dispatch(setActiveDepartment(teamId))
  }
  const handleClickCloseGreetingBtn = (e) => {
    e.preventDefault()

    const pd = window.parent.document // parent doc

    const frameStylesContent = `
    .raychat_frame{
      position: fixed;
      z-index: 2000000000;
      width: 100px; 
      height: 100px; 
      max-height: 714px;  
      border: 0;

      color-scheme: none;
      top : ${widgetPosition?.topSpace ? `calc(${widgetPosition?.topSpace} - 20px)` : 'auto'};
      left : ${widgetPosition?.leftSpace ? `calc(${widgetPosition?.leftSpace} - 20px)` : 'auto'};
      bottom: ${widgetPosition?.bottomSpace ? `calc(${widgetPosition?.bottomSpace} - 20px)` : '-5px'}; 
      right: ${widgetPosition?.rightSpace ? `calc(${widgetPosition?.rightSpace} - 20px)` : '-5px'};
      border-radius : 12px;
      box-shadow : none;
    }`
    const frameStyles = pd.getElementById('raychat_frame_styles')
    frameStyles.textContent = frameStylesContent
    dispatch(setShowTrigger(false))
  }
  const handleIframeLoad = () => {
    const iframe = iframeRef.current

    if (iframe) {
      const iframeDocument = iframe.contentDocument || iframe.contentWindow.document

      const iframeBody = iframeDocument.body

      iframe.style.height = `${iframeDocument.body.clientHeight}px`
      const styleElement = iframeDocument.createElement('style')

      styleElement.innerHTML =
        iframeStyles +
        `
        img {
          border-radius: 8px;
        }
      `

      iframeDocument.head.appendChild(styleElement)
      setIframeHeight(iframeBody.scrollHeight)

      if (iframeBody) {
        iframeBody.dir = languageInfo?.general?.direction ?? 'rtl'
      }

      if (!onLoadCalledOnce) setOnLoadCalledOnce(true)
    }
  }
  const handleFocusInput = () => setInputFocused(true)
  const handleBlurInput = () => setInputFocused(false)

  const handleClickGreetingBtn = () => dispatch(setShowLuancher(true))

  const renderInput = (
    <div data-focused={inputFocused} className="greeting_input_container">
      <input
        type="text"
        value={userInputValue}
        className="greeting_input raychat-font-regular"
        placeholder={languageInfo.texts.typeHere}
        onChange={handleUserInput}
        onKeyDown={handleKeyDown}
        onFocus={handleFocusInput}
        onBlur={handleBlurInput}
        id="user_input"
      />
      <div className="greeting_send_icon_container">
        <SendMessage onClick={sendNewMessage} className="greeting_send_icon" />
      </div>
    </div>
  )

  // this button is displayed when user has to fill form first before sending message
  const renderBtnInput = (
    <button onClick={handleClickGreetingBtn} className="greeting_button">
      <div className="greeting_button__text">
        <SmileyIcon className="greeting_button__icon" color="#FFF" />
        <span>{languageInfo.texts.startConversation}</span>
      </div>

      <LeftArrow className="greeting_button__arrow" color="#FFF" />
    </button>
  )

  const renderGreetingInput = showGreetingInput ? renderInput : renderBtnInput

  // wrap message in a `p` tag for better style
  // const getSrcDoc = () => activeAutoMessage.message || ''

  const getSrcDoc = () => `
    <!DOCTYPE html>
        <html lang='en'>
        <head>
        </head>
        <body>
          <div id='dynamic-text' class='truncate-text'>
            ${activeAutoMessage?.message || ''}
          </div>
          <script>
            function truncateTextByLength(elementId, maxLength) {
              var element = document.getElementById(elementId);
              var text = element.innerText;

              if (text.length > maxLength) {
                element.innerText = text.substring(0, maxLength) + '...';
              }
            }

            if(${shouldTruncateMessage}) {
              truncateTextByLength('dynamic-text', 250);  // Truncate by character length
            }
            
          </script>
        </body>
        </html>
  `

  useEffect(() => {
    if (shouldPlayNotifSound) {
      playNotifSound()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showTrigger])

  useEffect(() => {
    if (widgetInfo.data) {
      setWidgetPosition(widgetInfo.data.personalize.position)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [widgetInfo.data])

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (msgContentRef.current) {
      setMsgContentHeight(msgContentRef.current.clientHeight)
    }
  })

  useEffect(() => {
    dispatch(setAutoMessageSize(msgContentHeight))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [msgContentHeight])

  return (
    <div className="greeting_container_wrapper">
      <div className="greeting_container">
        <div className="greeting">
          <div className="greeting__header">
            {/* agent's avatar and name */}
            <div className="greeting__avatar_name">
              <Avatar operatorId={activeAutoMessage?.sender?.id} showTooltip={false} />
              <span className="greeting__agent_name">{activeAutoMessage?.sender?.title}</span>
            </div>

            <div className="greeting_actions" onClick={handleClickCloseGreetingBtn}>
              <Close className="close_greeting" color="#ffffff" pureSvg={true} />
            </div>
          </div>
          <div ref={msgContentRef} className="greeting_message_container" onClick={handleClickGreeting}>
            <iframe
              style={{ height: `${iframeHeight + 20}px`, width: '100%' }}
              title="greeting"
              srcDoc={getSrcDoc()}
              ref={iframeRef}
              onLoad={handleIframeLoad}
            />
          </div>
          {renderGreetingInput}
        </div>
      </div>
    </div>
  )
}

export default Greeting
